import { useCallback } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { useUser } from '../contexts/AuthContext'

/**
 * Wraps trackExperimentViewed with the correct logged_in value for jarvis-vision.
 *
 * The library function reads logged_in from the active_membership cookie, which is
 * set by the Rails backend for MC members. Educator users in jarvis-vision never
 * have this cookie, so the library always reports logged_in: false. This hook
 * overrides that with the actual auth state from AuthContext.
 *
 * IMPORTANT: The returned callback is no-op while auth is loading and re-creates
 * when auth resolves. Callers MUST include it in their useEffect dependency array
 * so the effect re-fires once loading completes.
 */
export const useTrackExperimentViewedWithAuth = () => {
  const { user, isLoading } = useUser()

  return useCallback(
    (
      experimentName: string,
      properties: Record<string, unknown> = {},
      options: { trackUserLeap?: boolean } = {},
    ) => {
      if (isLoading) return
      trackExperimentViewed(
        experimentName,
        { product: 'educator', ...properties, logged_in: !!user },
        options,
      )
    },
    [user, isLoading],
  )
}
